export default __webpack_public_path__ + "static/media/auth-image1.07dfbe1e.png";